import { createConsumer } from '@rails/actioncable'

// Single shared WebSocket connection reused by all channel subscriptions.
export const consumer = createConsumer()
